import React, { useContext, useEffect, useRef, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import styled from "styled-components";
import { ethers } from "ethers";
import Pusher from "pusher-js";
import { userBalanceContext } from "../../context/userBalanceContext";
import {
  init,
  balanceOf,
  getBalance,
} from "../../config/provider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
// import { Manager } from "socket.io-client";
import environmentVariables from "../../config/environmentVariables";
import { userInfoContext } from "../../context/userInfoContext";
const BellIcon = `${environmentVariables?.cdnUrl}bell.png`
const BlueArrow = `${environmentVariables?.cdnUrl}blue_arrow.png`
// const manager = new Manager(`${environmentVariables?.apiUrl}`);
// const socket = manager.socket("/");
const Root = styled.div`
  margin: 20px 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
`;

const CrossIcon = styled.img`
    position: absolute;
    top: 15px;
    right: 20px;
    width: 28px;
    height: 28px;
    display: none;
    @media (max-width: 768px) {
      display: block;
  }
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 90%;
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  z-index: 1;
  display: flex;
  gap: 10px;
  justify-content: end;
  align-items: center;
  text-align: center;

  @media (max-width: 425px) {
    right: 5%;
    /* flex-direction: column; */
    align-items: center;
    text-align: center;
    top: 0;
    gap: 5px;
  }
`;

const Button = styled.button`
  background: #172930;
  border-radius: 50px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #153339;
  padding: 12px 30px;
  color: #267383;
  @media (max-width: 425px) {
    font-size: 14px;
    padding: 14px 30px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  text-align: center;
`;

const AddressWrapper = styled.div``;

const AddressText = styled.text`
  font-size: 20px;
  font-weight: 800;
  text-align: left;
  color: #fff;
  line-height: 50px;
  padding: 0 10px;
  display: flex;
  @media (max-width: 768px) {
    /* display: none; */
  }
  @media (max-width: 425px) {
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    padding: 0 5px;
  }
`;
const CopyIcon = styled.div`
  color: white;
  cursor: pointer;
  padding: 0 10px 0 15px;
  @media (max-width: 425px) {
    padding: 0 5px 0 5px;
  }
`;
const BellMain = styled.div`
  position: relative;
`;
const Bell = styled.img`
  width: 25px;
  cursor: pointer;
  @media (max-width: 425px) {
    width: 20px;
  }
`;
const BellDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50px;
  background-color: #f71212;
  position: absolute;
  top: 0;
  right: 0;
`;
const NotificationPopMain = styled.div`
  background-color: #172930;
  border-radius: 10px 0 10px 10px;
  padding: 20px;
  color: #d1d1d1;
  font-size: 18px;
  /* box-shadow: 0px 0px 5px 5px #000; */
  position: absolute;
  z-index: 2;
  top: 35px;
  right: 130px;
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 500px;
  overflow-y: scroll;
  z-index: 999999;
  box-shadow: 0px 0px 11px 8px #242424a6;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #1e333b;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #1e889e;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  @media (max-width: 768px) {
    top: 0;
    left: 0;
    border-radius: 10px;
    right: 0;
    position: fixed;
    width: 100%;
    height: 100vh;
  }
  /* @media (max-width: 425px) {
    top: 50px;
    left: -49px;
    border-radius: 10px;
    right: 0;
  }
  @media (max-width: 375px) {
    left: -42px;
  } */
`;
const NotifivationsHead = styled.div`
  border-bottom: 1px solid #2b434d;
  padding-bottom: 15px;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
`;
const Notifivations = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #2b434d;
`;
const NotifivationsLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const LeftFrom = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1e889e;
`;
const LeftTime = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #526366;
  padding-top: 5px;
`;
const NotifivationsRight = styled.div``;

const LoginLogoutComponent = ({
  allContractDetails,
  setAllContractDetails,
  setIsNotificationOpen,
  isNotificationOpen,
}) => {
  const [address, setAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [isNotification, setIsNotification] = useState(false);
  const {userAccInfo,setUserAccInfo}=useContext(userInfoContext);

  const copyRef = useRef(null);
  const { userBalance, setUserBalance } = useContext(userBalanceContext);
  // const [userBalance, setUserBalance] = useState({
  //   MLDBalance: 0,
  //   LORDBalance: 0,
  //   MLD: 0,
  //   LORD: 0,
  //   MATICBalance: 0,
  //   MATIC: 0,
  // });
  const resetBalance = () => {
    setUserBalance({
      MLDBalance: 0,
      LORDBalance: 0,
      MLD: 0,
      LORD: 0,
      MATICBalance: 0,
      MATIC: 0,
    });
  };
  const getNotificationData = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getusertokentransferdata/${allContractDetails?.address}`,
        {headers:{
          authorization:`Bearer ${userAccInfo}`
        }}
      )
      .then((res) => {
        // console.log(res.data.data);
        setNotificationData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const CopyAddress = async () => {
    try {
      if (copyRef.current) {
        await navigator.clipboard.writeText(copyRef.current.value);
        toast.success("Copied !", {
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error("Error copying text:", error);
      toast.error("Copy failed");
    }
  };
  const getMonthName = (num) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sepr",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[num];
  };
  const getConvertedTime = (unixTimestamp) => {
    const date = new Date(unixTimestamp);

    // Get the various components of the date and time
    const year = date.getFullYear();
    const month = getMonthName(date.getMonth()); // Months are zero-indexed, so add 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // You can format these components as needed, for example, in a user-friendly string
    const formattedDate = `${month} ${day}, ${hours}:${minutes}`;

    // console.log(formattedDate);
    return formattedDate;
  };
  const getUserBalance = (address) => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{authorization:`Bearer ${userAccInfo}`}}
      )
      .then((res) => {
        // console.log(res.data.data);
        setUserBalance(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const setUserToken=(res)=>{
    if(res?.idToken){
      let loginType='provider';
      if(res?.userInfo?.typeOfLogin){
        loginType='provider';
      }else{
        loginType='email'
      }
      let data={
        userName:res?.userInfo?.email||res?.userInfo?.name||res?.userInfo?.verifierId||'metamask',
        address:res?.address,
        loginType:loginType
      }
      let config={
        method:"post",
        url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/token`,
        headers:{
          authorization:`Bearer ${res?.idToken?.idToken}`
        },
      }
      axios.post(config.url, data, config)
      .then( respnse=>{
        // console.log(respnse,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;s')
        if(respnse?.data?.data){
          localStorage.setItem('userinfo',respnse?.data?.data);
          setUserAccInfo(respnse?.data?.data);          
        }
      }).catch(async err=>{
        console.log(err);
        // toast.error(err?.response?.data?.message||err?.message)
        localStorage.clear();
        await logoutWallet();
      })
    }else{
      toast.error("id token is required")
    }

  }
  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher("cbb68a6fad0862e7fd60", {
      cluster: "ap2",
    });
    const channel = pusher.subscribe("notification-show");
    channel.bind("my-event", (data) => {
      if (allContractDetails) {
        getUserBalance(allContractDetails?.address);
      }
    });
    if (allContractDetails?.address) {
      const channel2 = pusher.subscribe(
        allContractDetails?.address.toLowerCase()
      );
      channel2.bind("notifications", (data) => {
        getNotificationData();
        setIsNotification(true);
      });
    }
  }, [allContractDetails]);
  // useEffect(() => {
  //   if (allContractDetails) {
  //     socket.emit("join_room", allContractDetails?.address);
  //     socket.on("receive_mld", async (data) => {
  //       getNotificationData();
  //       setIsNotification(true);
  //     });
  //   }
  // }, [socket, allContractDetails]);
  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails?.address;
      setAddress(address);
      getNotificationData();
    } else {
      setAddress("");
    }
  }, [allContractDetails]);
  useEffect(() => {
    // console.log(".................", data)
    if (localStorage.getItem("Web3Auth-cachedAdapter")) {
      setIsLoading(true);
      init()
        .then(async (response) => {
          setAllContractDetails(response);
          setUserToken(response)
          setIsLoading(false);
          if (!response) {
            setIsLoading(response);
          }
        })
        .catch((err) => {
          console.log(err, "responseafterlogin");
          setIsLoading(false);
        });
    }
  }, []);

  const getNotificationComponents = () => {
    if (notificationData == null) {
      return (
        <NotificationPopMain>
          <div>
            <NotifivationsHead>Notifications</NotifivationsHead>
            <Notifivations>Loading...</Notifivations>
          </div>
        </NotificationPopMain>
      );
    } else if (notificationData.length == 0) {
      return (
        <NotificationPopMain>
          <div>
            <NotifivationsHead>Notifications</NotifivationsHead>
            <Notifivations>No Data to show</Notifivations>
          </div>
        </NotificationPopMain>
      );
    } else {
      <NotificationPopMain>
        <div>
          <NotifivationsHead>Notifications</NotifivationsHead>
          {notificationData.map((val) => (
            <Notifivations>
              <NotifivationsLeft>
                <LeftFrom>{`From ${val.from.slice(0, 6)}...${val.from.slice(
                  -6
                )}`}</LeftFrom>
                <LeftTime>Recieved on Oct 6, 16.30</LeftTime>
              </NotifivationsLeft>
              <NotifivationsRight>2.00 MLD</NotifivationsRight>
            </Notifivations>
          ))}
        </div>
      </NotificationPopMain>;
    }
  };
  const connectWallet = async () => {
    setIsLoading(true);
    try {
      const data = await init();
      setIsLoading(false);
      // console.log(".................", data);
      setAllContractDetails(data);
      setUserToken(data)
      const address = data.address;
      
      // console.log(allContractDetails, "sr");
      const mldBal = await balanceOf(data?.mldTokenContract, address);
      const lordBal = await balanceOf(data?.lordTokenContract, address);
      const maticBal = await getBalance(data.provider, address);
      // await approve(data?.mldTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.lordTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.usdtTokenContract, metaspaceNFTMarketplaceAddress);
      // await approve(data?.mldTokenContract, metaspaceNFTMarketplaceAddress);
      // const ownership=await transferOwnership(data.metalordNFTManagerContract,'0x465d2634aC8DE6672A220F5034d8ad690b93cF72')
      // const owner=await data.metalordNFTManagerContract(address,'0x5bDb767f63376Dbc8B8AFA1E6d8b193fD7320721')
      // console.log('ownership', ownership)
      setUserBalance({
        MLDBalance: parseInt(mldBal),
        LORDBalance: parseInt(lordBal),
        MLD: ethers.utils.formatEther(mldBal),
        LORD: ethers.utils.formatEther(lordBal),
        MATICBalance: parseInt(maticBal),
        MATIC: ethers.utils.formatEther(maticBal),
      });
      setIsLoading(false);
    } catch (error) {
      console.log("Error:", error);
    }

    setIsLoading(false);
  };

  const logoutWallet = async () => {
    setIsLoading(true);

    try {
      await allContractDetails?.logout();
      resetBalance();
      setAllContractDetails(null);
    } catch (error) {
      console.log("Error:", error);
    }
    setIsLoading(false);
  };

  return (
    <Root>
      <LoadingOverlay active={isLoading} spinner>
        <Container>
          {address ? (
            <Wrapper>

{isNotificationOpen && (
                    <NotificationPopMain>
                      <div>
                        <NotifivationsHead>Notifications <CrossIcon src={BlueArrow} /></NotifivationsHead>
                        {notificationData &&
                          notificationData.map((val) => (
                            <Notifivations>
                              <NotifivationsLeft>
                                <LeftFrom>{`From ${val.from.slice(
                                  0,
                                  6
                                )}...${val.from.slice(-6)}`}</LeftFrom>
                                <LeftTime>{`Recieved on ${getConvertedTime(
                                  val?.time
                                )}`}</LeftTime>
                              </NotifivationsLeft>
                              <NotifivationsRight>{`${val?.amount} ${val?.currency}`}</NotifivationsRight>
                            </Notifivations>
                          ))}
                      </div>
                    </NotificationPopMain>
                  )}


              <ButtonWrapper>
                <AddressWrapper>
                  <AddressText>
                    <CopyIcon onClick={CopyAddress}>
                      <i class="fa-solid fa-copy"></i>
                      <ToastContainer position="top-left" />
                    </CopyIcon>
                    {address.slice(0, 4)}...
                    {address.slice(address.length - 4, address.length)}
                    {/* {address} */}
                    <input
                      ref={copyRef}
                      type="text"
                      style={{ position: "absolute", left: "-9999px" }}
                      value={address}
                      readOnly
                    />
                  </AddressText>
                </AddressWrapper>
                <BellMain>
                  <Bell
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsNotification(false);
                      setIsNotificationOpen(!isNotificationOpen);
                    }}
                    src={BellIcon}
                  />
                  {isNotification && <BellDot></BellDot>}

                  
                </BellMain>
                <Button onClick={logoutWallet} disabled={isLoading}>
                  Logout
                </Button>
                {isLoading ? "Disconnecting..." : " "}
              </ButtonWrapper>
            </Wrapper>
          ) : (
            <ButtonWrapper>
              <Button onClick={connectWallet} disabled={isLoading}>
                Log In
              </Button>
              {isLoading ? "Connecting..." : " "}
            </ButtonWrapper>
          )}
        </Container>
      </LoadingOverlay>
    </Root>
  );
};

export default LoginLogoutComponent;
